import {MenuScrollClass} from "./menu-scroll/menu-scroll.class";
import {MenuToggleClass} from "./menu-toggle/menuToggle.class";
import {DropdownClass} from "./dropdown/dropdown.class";
import MapClass from "./map/map.class";
import {mobileRealHeight} from "./module/mobile-real-height.function";
import {FormValidateClass} from "./form/form-validate.class";
import {InViewportClass} from "./in-viewport/in-viewport.class";
import {InstagramFeedClass} from "./module/instagram/instagram-feed.class";
import {SwiperControllerClass} from "./swiper-controller/swiper-controller.class";
import {TabLink} from "./tab-link/tab-link.class";
import {Popover} from "./popover/popover.class";
import {PopTrigger, PopTriggerCallableName} from "./pop-trigger/pop-trigger.class";
import {CookieConsentClass} from "./cookie-consent/cookie-consent.class";
import {SpecialEventPopover} from "./popover/special-event-popover.class";
const pictureFill = require('picturefill');

export class App {
    private specialEventPopover: SpecialEventPopover;
    constructor() {
        new CookieConsentClass();
        mobileRealHeight();
        const inViewportListener = new InViewportClass();
        const instagramFeed = new InstagramFeedClass();
        new MenuScrollClass();
        new MenuToggleClass();
        new DropdownClass();
        const map = new MapClass();
        map.viewportListener(inViewportListener);
        new FormValidateClass();
        new SwiperControllerClass();
        new Popover();
        this.specialEventPopover = new SpecialEventPopover();

        inViewportListener.addElement('.js-instagram-feed', () => {
            instagramFeed.init()
        });

        Array.from(document.querySelectorAll('.js-img-appear')).forEach(img => {
            inViewportListener.addElement(img as HTMLElement, (e: HTMLElement) => {
                e.classList.add('is-visible');
            }, true, 500);
        });

        const tabLink = new TabLink();

        tabLink.clicked().subscribe(sectionElem => {
           sectionElem.scrollIntoView({ block: 'start', behavior: 'smooth'});
        });

        (tabLink.getTabTargets() || []).forEach(tabTarget => {
            inViewportListener.addElement(tabTarget, (e: HTMLElement) => {
                const trigger = tabLink.getTrigger(e.getAttribute('data-section-id'));
                if (trigger) {
                    tabLink.toggleActiveClass(trigger);
                }
            }, false);
        })

        new PopTrigger({
            'calculateSectionHeight': {
                [PopTriggerCallableName.BEFORE_ACTIVE]: ($trigger: HTMLElement, $target: HTMLElement) => {
                    const $section: HTMLElement = $target.querySelector('.js-section-height');
                    $section.style.height = $section.getBoundingClientRect().height + 'px';
                }
            },
            'closeSpecialEventPopover': {
                [PopTriggerCallableName.DIRECTLY_AFTER_HIDDEN]: () => {
                    this.specialEventPopover.saveClosedState();
                }
            }
        });
    }
}

new App();
